<template>
  <div class="top-search-bar--spacer">
    <section class="top-search-bar" :class="{ 'sticky-header': stickedHeader }">
      <div class="content-wrapper">
        <a class="logo-allegro" href="https://allegro.pl/">
          <img src="@/assets/images/logo_allegro.svg" alt="Logo Allegro" />
        </a>
        <!-- <a class="logo-wosp" href="https://www.wosp.org.pl/">
          <img src="@/assets/images/logo_wosp.png" alt="Aukcje Wielkiej Orkiestry Świątecznej Pomocy" />
        </a> -->
        <!-- <div class="search-input">
          <input
            v-model="search_string"
            v-on:keyup.enter="doAllegroSearch()"
            type="text"
            placeholder="czego szukasz?"
          />
          <button @click.prevent="doAllegroSearch()">Szukaj</button>
        </div> -->
        <!-- <a class="btn-sell-item" href="#" @click="buyBrick()">Kup cegiełkę</a> -->
      </div>
      <!-- <div class="content-wrapper content-wrapper--mobile">
        <div class="search-input-mobile">
          <input
            v-model="search_string"
            v-on:keyup.enter="doAllegroSearch()"
            type="text"
            placeholder="czego szukasz?"
          />
          <button @click.prevent="doAllegroSearch()">Szukaj</button>
        </div>
      </div> -->
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      search_string: "",
      stickedHeader: false
    };
  },
  methods: {
    sendSellItemAnalytics: function() {
    //   ga("send", "event", "header", "button click", "wystaw przedmiot");
    },
    buyBrick: function () {
        this.sendSellItemAnalytics();
        this.$scrollTo("#kup-cegielke", 300, {
            offset: -100
        });
    },
    doAllegroSearch: function() {
      if (this.search_string.length) {
        // ga("send", "event", "header", "button click", "szukaj");
        window.location.href =
          "https://allegro.pl/listing?string=" +
          this.search_string;
      }
    },
    handleStickHeaderOnScroll(event) {
      if (window.innerWidth > 991) {
        if (window.pageYOffset >= 72) {
          this.stickedHeader = true;
        } else {
          this.stickedHeader = false;
        }
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleStickHeaderOnScroll);
  }
};
</script>

<style lang="scss">
@import "@/scss/_general.scss";
.top-search-bar--spacer {
  height: 80px;

  @media only screen and (max-width: 991px) {
    height: auto;
  }
}

.top-search-bar {
  height: 80px;
  background: #fff;
  border-bottom: 1px #ddd solid;

  &.sticky-header {
    width: 100%;
    position: fixed;
    top: 0px;
    z-index: 101;
  }

  @media only screen and (max-width: 991px) {
    height: auto;
  }

  .content-wrapper {
    height: 80px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: relative;

    @media only screen and (max-width: 991px) {
      height: 50px;
    }

    & > a {
      max-height: 100%;

      &.logo-allegro {
        img {
          height: 42px;
          margin-right: 40px;

          @media only screen and (max-width: 991px) {
            height: 30px;
            margin-right: 24px;
          }
        }
      }

      &.logo-wosp {
        img {
          height: 60px;

          @media only screen and (max-width: 991px) {
            height: 40px;
          }
        }
      }
    }

    .btn-sell-item {
      font-size: 14px;
      line-height: 14px;
      color: #222;
      height: 40px;
      padding: 0 20px;
    //   border: 1px #767676 solid;
      display: flex;
      align-items: center;
      text-decoration: none;
      justify-self: flex-end;
      margin-left: auto;
      // margin-right: 40px;
    //   border-radius: 2px;

      @media only screen and (max-width: 576px) {
        // margin-right: 20px;
      }

      @media only screen and (max-width: 480px) {
        // display: none;
        margin-left: auto;
        font-size: 12px;
        text-align: center;
        padding: 0 15px;
        flex: 0;
      }

      &:hover {
        color: #00a790;
      }

      // @media only screen and (max-width: 991px) {
      //   height: 30px;
      //   font-size: 12px;
      //   padding: 0px 15px;
      // }
    }
  }

  .search-input {
    width: 46.52%;
    height: 40px;
    display: flex;
    flex-direction: row;
    position: absolute;
    left: 50%;

    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -o-transform: translateX(-50%);
    transform: translateX(-50%);

    @media only screen and (max-width: 1200px) {
      width: 50%;
      left: 53%;
    }

    @media only screen and (max-width: 1080px) {
      width: 50%;
      left: 53%;
    }

    @media only screen and (max-width: 1200px) {
      width: 45%;
    }

    @media only screen and (max-width: 991px) {
      display: none;
    }

    input[type="text"] {
      width: 100%;
      border: 1px #c3c3c3 solid;
      border-right: 0px;
      border-radius: 2px 0 0 2px;
      font-size: 14px;
      font-weight: 400;
      padding: 0 13px;
    }

    button {
      background: $orange1;
      border: none;
      border-radius: 0 2px 2px 0;
      text-transform: uppercase;
      color: #fff;
      font-weight: 300;
      font-size: 14px;
      line-height: 19px;
      letter-spacing: 1.6px;
      padding: 0px 20px;
      cursor: pointer;

      &:hover {
        background: $orange1hover;
      }
    }
  }

  .content-wrapper--mobile {
    height: 40px;
    background: #fff;
    display: none;

    @media only screen and (max-width: 991px) {
      height: 60px;
      display: flex;
    }
  }

  .search-input-mobile {
    width: 100%;
    height: 40px;
    display: flex;
    flex-direction: row;

    input[type="text"] {
      width: 100%;
      border: 1px #c3c3c3 solid;
      border-right: 0px;
      border-radius: 2px 0 0 2px;
      font-size: 14px;
      font-weight: 400;
      padding: 0 13px;
    }

    button {
      background: $orange1;
      border: none;
      border-radius: 0 2px 2px 0;
      text-transform: uppercase;
      color: #fff;
      font-weight: 300;
      font-size: 14px;
      line-height: 19px;
      letter-spacing: 1.6px;
      padding: 0px 20px;
      cursor: pointer;

      &:hover {
        background: $orange1hover;
      }
    }
  }
}
</style>
